var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { I18nService } from '@app/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { UserService } from '@app/user.service';
import { Observable } from 'rxjs';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(Auth, router, i18nService, util, apiService, UserService) {
        this.Auth = Auth;
        this.router = router;
        this.i18nService = i18nService;
        this.util = util;
        this.apiService = apiService;
        this.UserService = UserService;
        this.isLoading = false;
        this.DefaultRoute = "/mainmenu/ticketlist";
    }
    LoginComponent.prototype.handleKeyboardEvent = function (event) {
        if (event.key == "Enter") {
            this.Login();
        }
    };
    LoginComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                document.body.className = 'hold-transition login-page';
                localStorage.removeItem("AgentBank_Profile");
                // step-1
                this.captcha = new Captcha($('#canvas'), {
                    length: 6
                });
                // api
                //captcha.refresh();
                //captcha.getCode();
                // //captcha.valid("");
                // $('#valid').on('click', function() {
                //   const ans = captcha.valid($('input[name="code"]').val());
                //   alert(ans);
                //   captcha.refresh();
                // })
                //await this.CallApi();
                this.InitDropdownItems();
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.CallApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, forkJoin([])];
            });
        });
    };
    LoginComponent.prototype.InitDropdownItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                Observable.forkJoin(this.apiService.get("master", "companyType"), this.apiService.get("master", "personalType"), this.apiService.getMasterAddress()).subscribe(function (data) {
                    localStorage.removeItem("companyType");
                    localStorage.removeItem("personalType");
                    localStorage.removeItem("address");
                    localStorage.setItem("companyType", JSON.stringify(data[0]));
                    localStorage.setItem("personalType", JSON.stringify(data[1]));
                    localStorage.setItem("address", JSON.stringify(data[2]));
                }, function (err) { return console.error(err); });
                return [2 /*return*/];
            });
        });
    };
    LoginComponent.prototype.Login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var UserName, Password, ans, data, Profile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        UserName = $('#username').val();
                        Password = $('#password').val();
                        if (UserName == "") {
                            this.util.WarningDialog("กรุณาระบุชื่อผู้ใช้");
                            return [2 /*return*/];
                        }
                        if (Password == "") {
                            this.util.WarningDialog("กรุณาระบุรหัสผ่าน");
                            return [2 /*return*/];
                        }
                        ans = this.captcha.valid($('input[name="code"]').val());
                        if (!ans) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Auth.LogIn(UserName, Password)];
                    case 1:
                        data = _a.sent();
                        if (!(data["RESMSG"] == "SUCCESS")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.Auth.GetProfile(UserName)];
                    case 2:
                        Profile = _a.sent();
                        if (Profile[0].dpa_forcechangepassword == true) {
                            $('#lblError').html('');
                            $('#dlgChngPwd').modal({
                                backdrop: 'static',
                                keyboard: false
                            });
                        }
                        else {
                            localStorage.setItem("AgentBank_Profile", UserName);
                            localStorage.setItem("AgentBank_UserID", Profile[0].dpa_agentbankuserid);
                            this.router.navigate([this.DefaultRoute]);
                            this.Auth.setLoggedIn(true);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.WarningDialog("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
                        return [2 /*return*/];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        $('input[name="code"]').val("");
                        this.captcha.refresh();
                        $('input[name="code"]').css("background-color", "crimson");
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.CheckSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var str, data, res, check, res2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = '';
                        $('#divData').html(str);
                        data = {};
                        data['member_no'] = $('#txtUserName').val();
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'GetUserSession', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        console.log('res', res);
                        check = 0;
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                if (res.responseData.length > 0) {
                                    check++;
                                    this.ip_add = res.responseData[0].ip_address;
                                }
                            }
                        }
                        if (!(check == 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'InsertUserSession', data)];
                    case 2:
                        res2 = _a.sent();
                        this.VisitApp(this.url);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.VisitApp = function (url) {
        // window.location.href = url;
        console.log('url', url);
        this.router.navigate([url]);
    };
    LoginComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language;
    };
    Object.defineProperty(LoginComponent.prototype, "currentLanguage", {
        get: function () {
            return this.i18nService.language;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.ForgetPassword = function () {
        $('#txtMemberNo').val($('#txtUserName').val());
        $('#txtOldPassword').val('');
        $('#txtNewPassword').val('');
        $('#txtConfirmNewPassword').val('');
        $('#lblError').html('');
        $('#lblSuccess').html('');
        $('#dlgForgetPassword').modal({ backdrop: 'static', keyboard: false });
    };
    LoginComponent.prototype.SavePassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var NewPwd, CurrPwd, UserName, Res, Profile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        NewPwd = $('#txtNewPwd').val();
                        CurrPwd = $('#password').val();
                        if (NewPwd == "") {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่');
                            return [2 /*return*/];
                        }
                        if (NewPwd == CurrPwd) {
                            $('#lblPwdError').html('**กรุณาระบุรหัสผ่านใหม่ให้ต่างจากรหัสผ่านปัจจุบัน');
                            return [2 /*return*/];
                        }
                        if (!this.UserService.IsValidatePassword(NewPwd)) {
                            $('#lblPwdError').html('**รหัสผ่านใหม่ไม่ตรงตามข้อกำหนด');
                            return [2 /*return*/];
                        }
                        if (NewPwd != $('#txtConfirmPwd').val()) {
                            $('#lblPwdError').html('**กรุณายืนยันรหัสผ่านให้ตรงกัน');
                            return [2 /*return*/];
                        }
                        UserName = $('#username').val();
                        return [4 /*yield*/, this.UserService.ChangePassword(UserName, CurrPwd, NewPwd)];
                    case 1:
                        Res = _a.sent();
                        if (!(Res["RESMSG"] == "SUCCESS")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.Auth.GetProfile(UserName)];
                    case 2:
                        Profile = _a.sent();
                        localStorage.setItem("AgentBank_Profile", UserName);
                        localStorage.setItem("AgentBank_UserID", Profile[0].dpa_agentbankuserid);
                        this.Auth.setLoggedIn(true);
                        this.util.SuccessDialog('บันทึกสำเร็จ');
                        setTimeout(function () {
                            $('#btnCloseDlg').click();
                            _this.router.navigate([_this.DefaultRoute]);
                        }, 1000);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog('บันทึกไม่สำเร็จ');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts.pre-build-optimizer.js